import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { trackEditColumnsClicked } from '../../tracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditColumnsButton = ({
  hideIcon = false,
  onClick,
  size,
  use
}) => {
  return /*#__PURE__*/_jsxs(UIButton, {
    "data-selenium-test": "edit-columns-button",
    onClick: () => {
      trackEditColumnsClicked();
      onClick();
    },
    size: size,
    use: use,
    children: [!hideIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "editColumns"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tableColumnEditor.editColumnsButtonLabel"
    })]
  });
};
export default EditColumnsButton;